import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveBreakRule {
  id?: '';
  name: string;
  length: number;
  no_set_length: boolean;
  paid: boolean;
  cannot_end_early: boolean;
  end_break_automatically: boolean;
  notify_before_break_ends: boolean;
}

const saveBreakRule = ({ id, ...postData }: ISaveBreakRule) => {
  if (id) {
    const updatedEndpoints = endpoints.breakRules.breakRulesById.replace('{id}', id);
    return http().put(updatedEndpoints, postData);
  } else return http().post(endpoints.breakRules.base, postData);
};

export function useSaveBreakRule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveBreakRule,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchPaginatedBreakRules'] });
    },
  });
}
